export default __webpack_public_path__ + "static/media/kg.bdba4197.jpg";